<div class="dialog-wrapper">
    <mat-dialog-content>
        <span class="dot" *ngIf="selectType === 'done'"></span>
        <span class="delete" *ngIf="selectType === 'exist'">
            <mat-icon>delete</mat-icon>
        </span>
        <p class="dialog-p-1" *ngIf="selectType === 'done'"><span>This page has been saved</span></p>
        <p class="dialog-p-1" *ngIf="selectType === 'exist'"><span>Do you want to remove this page from your saved
                list?</span></p>
        <input *ngIf="selectType === 'new'" type="text" class="input-text"
            placeholder="Please write a note about this page" [(ngModel)]="noteText">
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-action" *ngIf="selectType === 'exist'">
        <button mat-raised-button color="primary" matDialogClose="yes" class="btn-cancel"><span>No</span></button>
        <button mat-raised-button color="primary" class="btn-yes" (click)="deletePage()"><span>Yes</span></button>
    </mat-dialog-actions>
    <mat-dialog-actions class="dialog-action" *ngIf="selectType === 'new'">
        <button mat-raised-button color="primary" matDialogClose="yes" class="btn-cancel"><span>Cancel</span></button>
        <button mat-raised-button color="primary" class="btn-yes" (click)="savePage()"><span>OK</span></button>
    </mat-dialog-actions>
    <mat-dialog-actions class="dialog-action" *ngIf="selectType === 'done'">
        <button mat-raised-button color="primary" class="btn-yes" (click)="dialogClose()"><span>OK</span></button>
    </mat-dialog-actions>
</div>